export { default } from "./PhotoLinkButton.jsx"
